import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class LineInformationComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentSecundaryColor = "#F5F5F5";
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        const geometryWidthRatio = geometry.width / 1200.0 * dimentionsRatio;
        const geometryHeightRatio = geometry.height / 200.0 * dimentionsRatio;

        const height = 100 * geometryHeightRatio;
        const smallWidth = 200 * geometryWidthRatio;
        const bigWidth = 850 * geometryWidthRatio;

        const firstElementPosX = geometry.drawPositionX + 50 * geometryWidthRatio;
        const secondElementPosX = geometry.drawPositionX + 300 * geometryWidthRatio;

        const rectElementPosY = geometry.drawPositionY + 50 * geometryHeightRatio;
        const fontElementPoxY = rectElementPosY + height / 5.0;

        let fontSize = height * 0.75;
        if (6.5 * fontSize > geometryWidth) {
            fontSize = geometryWidth / 6.5;
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Rect x={firstElementPosX}
                        y={rectElementPosY}
                        width={smallWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Text text="Cód"
                        fontSize={fontSize}
                        x={firstElementPosX + 1}
                        y={fontElementPoxY}
                        fill="black" />
                </Group>
                <Group>
                    <Rect x={secondElementPosX}
                        y={rectElementPosY}
                        width={bigWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Text text="Linha"
                        fontSize={fontSize}
                        x={secondElementPosX + 1}
                        y={fontElementPoxY}
                        fill="black" />
                </Group>
            </Group>
        );
    }
}
